<div *ngIf="isDeleted" class="secondary-info">({{ "deleted_user" | localize }})</div>

<div *ngIf="!isDeleted && fullName" class="user-full-name">
  <span [class.d-block]="ghFullNameSettings.multiline" class="gh-name" [uiBoldTerm]="ghFullNameSearchTerm" [attr.data-test-id]="'fullName-' + fullName">{{ fullName }}</span>
  <ng-container *ngIf="isDeactivated">
    <span class="secondary-info deactivated" [class.d-block]="ghFullNameSettings.multiline" [class.text-center]="ghFullNameSettings.center">({{ "deactivated" | localize }})</span>
  </ng-container>
</div>
